// Each host also matches its subdomains, e.g. us-east-1.console.aws.amazon.com
const CLOUD_CONSOLE_HOSTS = [
  // AWS, including GovCloud and China
  'console.aws.amazon.com',
  'signin.aws.amazon.com',
  'console.amazonaws-us-gov.com',
  'signin.amazonaws-us-gov.com',
  'console.amazonaws.cn',
  'signin.amazonaws.cn',
  // Azure, including US Government and China
  'portal.azure.com',
  'portal.azure.us',
  'portal.azure.cn',
  'entra.microsoft.com',
  // Google Cloud
  'console.cloud.google.com',
  'shell.cloud.google.com',
  // Oracle Cloud
  'cloud.oracle.com',
];

export function isCloudConsoleUrl(href: string | null | undefined): boolean {
  if (!href) {
    return false;
  }

  let url: URL;
  try {
    url = new URL(href);
  } catch {
    return false;
  }
  if (url.protocol !== 'https:') {
    return false;
  }

  const hostname = url.hostname.toLowerCase();
  return CLOUD_CONSOLE_HOSTS.some(
    (host) => hostname === host || hostname.endsWith(`.${host}`),
  );
}
